const parseEnvBoolean = (value) => {
  const normalized = String(value || '').trim().toLowerCase();
  if (!normalized) {
    return null;
  }
  if (['1', 'true', 'yes', 'on'].includes(normalized)) {
    return true;
  }
  if (['0', 'false', 'no', 'off'].includes(normalized)) {
    return false;
  }
  return null;
};

const getEnabledRoles = () =>
  new Set(
    String(process.env.REACT_APP_AI_ENABLED_ROLES || 'client,partner')
      .split(',')
      .map((value) => value.trim().toLowerCase())
      .filter(Boolean),
  );

const isNonProductionHost = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  const hostname = String(window.location.hostname || '').toLowerCase();
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '0.0.0.0' ||
    hostname.endsWith('.local') ||
    hostname.includes('staging') ||
    hostname.includes('dev') ||
    hostname.includes('qa')
  );
};

export const isAiAssistantEnabledForRole = (role) => {
  const normalizedRole = String(role || '').toLowerCase();
  if (!['client', 'partner'].includes(normalizedRole)) {
    return false;
  }

  const explicitFlag = parseEnvBoolean(process.env.REACT_APP_AI_ENABLED);
  const globallyEnabled = explicitFlag ?? isNonProductionHost();

  return globallyEnabled && getEnabledRoles().has(normalizedRole);
};
